import { track } from '@/utils/analytics';
import { EVENT_TRACKING_PARAMS } from '../constants';

const splitStringByCapitalLetterRegex = /(?=[A-Z])/;
const SPACE_DELIMITER = ' ';
const minMaxMapper = {
  min: 'Minimum',
  max: 'Maximum',
};

const SearchFiltersEvents = {
  methods: {
    emitChange(filters) {
      this.$emit('change', filters);
    },
    emitReset() {
      this.$emit('reset');
    },
    emitSubmit() {
      this.$emit('submit');
    },
    trackFilterChange(filterType, value) {
      const hasAction = this.getHasAction(value);
      const filterName = this.addWordDelimiter(filterType, SPACE_DELIMITER);
      const trackFilterValue = hasAction ? value[value.action] : value;
      const trackFilterName = hasAction ? `${value.action} ${filterName}` : filterName;
      const trackEvent = `Search Listings_${this.parseFilterTrackName(trackFilterName, hasAction)} filter selected`;
      const trackParam = hasAction
        ? `${value.action}${this.capitalizeFirstLetter(EVENT_TRACKING_PARAMS[filterType])}`
        : EVENT_TRACKING_PARAMS[filterType];

      track(trackEvent, { [trackParam]: trackFilterValue });
    },
    getHasAction(filterValue) {
      return typeof filterValue === 'object' && 'action' in filterValue;
    },
    addWordDelimiter(string, delimiter) {
      return string.split(splitStringByCapitalLetterRegex).join(delimiter);
    },
    parseFilterTrackName(trackFilterName, hasAction) {
      if (hasAction) {
        const [action, ...filter] = trackFilterName.split(SPACE_DELIMITER);
        return `${minMaxMapper[action]} ${filter.join(SPACE_DELIMITER).toLowerCase()}`;
      }

      return this.capitalizeFirstLetter(trackFilterName);
    },
    capitalizeFirstLetter(string) {
      const [firstChar, ...rest] = string;
      return `${firstChar.toUpperCase()}${rest.join('')}`;
    },
  },
};

export default SearchFiltersEvents;
